import DOMPurify from "dompurify";

/* 服务端生成的 HTML（邮件 / 催收预览 / 提交函正文）渲染前统一消毒 */
export const safeHtml = (html) => ({ __html: DOMPurify.sanitize(html || "", { USE_PROFILES: { html: true } }) });
